module.exports = __webpack_public_path__ + "static/img/2_1_3.3b152ac6.jpg";